import React from "react";
import "./css/currenticon.css";

function SetIcon(props) {
  return <i className={props.class} id="current-icon"></i>;
}

export default SetIcon;
